import React, { useState, useEffect } from "react";

const Pagination = ({ showPerPage, onPaginationChange, total }) => {
  const [counter, setCounter] = useState(1);
  const [numberOfButtons, setnumberOfButtons] = useState();
  const [pageNumbers, setPageNumbers] = useState([]);
  const arrayOfPagination = [];

  const numButton = Math.ceil(total / showPerPage);

  for (let i = 1; i < numButton; i++) {
    arrayOfPagination.push(i);
  }

  // useEffect(() => {
  //   craftPagination();
  // }, [total]);

  useEffect(() => {
    const value = showPerPage * counter;
    onPaginationChange(value - showPerPage, value);
  }, [counter]);

  const onButtonClick = (type) => {
    if (type === "prev") {
      if (counter === 1) {
        setCounter(1);
      } else {
        setCounter(counter - 1);
      }
    } else if (type === "next") {
      if (numButton === counter) {
        setCounter(counter);
      } else {
        setCounter(counter + 1);
      }
    }
  };
  return (
    <div className="pagination">
      <ul>
        <li onClick={() => onButtonClick("prev")} className="btn prev">
          <span>
            <i className="fas fa-angle-left"></i> Prev
          </span>
        </li>

        {/* {arrayOfPagination.map((el, index) => (
          <li
            onClick={() => setCounter(index + 1)}
            className={`last numb ${index + 1 === counter ? "active" : null}`}
          >
            <span>{index + 1}</span>
          </li>
        ))} */}

        <li onClick={() => onButtonClick("next")} className="btn next">
          <span>
            Next <i className="fas fa-angle-right"></i>
          </span>
        </li>
      </ul>
    </div>
  );
};

export default Pagination;
